import { useEffect, useRef, useState } from "react";
import { Play, Pause } from "lucide-react";

const CLIPS = [
  { id: "onyx", label: "Deep" },
  { id: "coral", label: "Warm" },
];

export const VoiceSample = ({ className = "" }) => {
  const [playing, setPlaying] = useState(null);
  const audioRef = useRef(null);

  useEffect(() => () => { try { audioRef.current?.pause(); } catch {} }, []);

  const toggle = (id) => {
    try { audioRef.current?.pause(); } catch {}
    if (playing === id) { setPlaying(null); return; }
    const a = new Audio(`/voice-samples/${id}.mp3`);
    audioRef.current = a;
    a.onended = () => setPlaying(null);
    a.onerror = () => setPlaying(null);
    setPlaying(id);
    a.play().catch(() => setPlaying(null));
  };

  return (
    <div className={`card-panel p-4 ${className}`} data-testid="voice-sample">
      <div className="eyebrow text-[#FD0F10]">HEAR YOUR COACH</div>
      <p className="mt-1 text-sm text-gray-300">On Pro, your coach talks with you out loud. Tap to hear a 10 second sample.</p>
      <div className="mt-3 flex gap-2 flex-wrap">
        {CLIPS.map((c) => (
          <button
            key={c.id}
            onClick={() => toggle(c.id)}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg border text-sm font-semibold transition-colors ${playing === c.id ? "border-[#FD0F10] bg-[#FD0F10]/10 text-white" : "border-[#2A2E39] text-gray-200 hover:border-[#FD0F10]"}`}
            data-testid={`voice-sample-${c.id}`}
          >
            {playing === c.id ? <Pause size={15} className="text-[#FD0F10]" /> : <Play size={15} />}
            {c.label} voice
          </button>
        ))}
      </div>
    </div>
  );
};
